import { render, staticRenderFns } from "./RevisarChapuzon2026.vue?vue&type=template&id=7acc9f79&scoped=true&"
import script from "./RevisarChapuzon2026.vue?vue&type=script&lang=ts&"
export * from "./RevisarChapuzon2026.vue?vue&type=script&lang=ts&"
import style0 from "./RevisarChapuzon2026.vue?vue&type=style&index=0&id=7acc9f79&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7acc9f79",
  null
  
)

export default component.exports